import { Injectable } from '@angular/core';
import * as XLSX from "xlsx";
@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor() { }

  exportToExcel(excelData:any, fileName1:string = "") {  
    const fileName = fileName1 == "" ? "export.xlsx" : fileName1 + ".xlsx";
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "sheet1");
    XLSX.writeFile(wb, fileName);
  }
}
